import type { IconProps } from '../types/IconProps.ts';
export const ArrowUpRight: IconProps = {
    name: 'ArrowUpRight',
    children: [
        `<path d="M7 7h9.5c.28 0 .5.22.5.5V17M7 17l9-9" />`,
    ]
};